import { updateDocument } from "../../helpers";

export default function removeVendor(firebase, ref, vendorKey) {
	return updateDocument(ref, {
		[`vendors.${vendorKey}`]: firebase.firestore.FieldValue.delete(),
	});
}
